import * as _ from 'lodash-es';

import { Dispatch } from 'redux';

import {
  enqueueSnackbarCustomMessageHandler,
  enqueueSnackbarHandler,
} from '../Status';
import {
  ACTION_GET_TRANSACTIONS_BY_PARAMS,
  ACTION_GET_TRANSACTIONS_BY_PARAMS_FAILURE,
  ACTION_GET_TRANSACTIONS_BY_PARAMS_SUCCESS,
  API_CALL,
} from '../../configs/ActionTypes';

type Params = {
  amount?: string;
  postingDate?: string;
  last4?: string;
  merchant?: string;
  startDate?: string;
  endDate?: string;
};

export function getTransactionsByParams(orgId: string, params: Params = {}) {
  const queryParams = new URLSearchParams();
  queryParams.set('orgId', orgId);
  _.forEach(params, (val, key) => val && queryParams.set(key, val));
  const url = `transactions?${queryParams}`;
  return (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_GET_TRANSACTIONS_BY_PARAMS,
    });
    dispatch({
      type: API_CALL,
      payload: {
        call: url,
        method: 'get',
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarCustomMessageHandler(
              dispatch,
              response.payload.payload.name,
              'error',
            );
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          if (error.payload) {
            enqueueSnackbarCustomMessageHandler(
              dispatch,
              error.payload.name,
              'error',
            );
          }
          dispatch(requestFailed(error));
        },
      },
    });
  };
}

function requestFailed(errorJSON: object) {
  return {
    type: ACTION_GET_TRANSACTIONS_BY_PARAMS_FAILURE,
    payload: errorJSON,
  };
}

function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_TRANSACTIONS_BY_PARAMS_SUCCESS,
    payload: responseJSON,
  };
}
